<template>
  <component :is="layout">
    <slot />
  </component>
</template>

<script>
import DefaultLayout from "@/layouts/options/Default.vue";

export default {
  name: "Layout",
  computed: {
    layout() {
      if (!this.$route.name) return;

      if (this.$route.meta.layout) return () => import(`@/layouts/options/${this.$route.meta.layout}.vue`);

      return DefaultLayout;
    },
  },
};
</script>
